import { toastifyFn } from 'common/utilities/utils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getCustomerInfo } from '@kfc-global/react-shared/redux/Actions/OrderservAction';

export const getCardIconFromContentFul = (allCardsTypesList, cardtype) => {
  return allCardsTypesList
    ?.filter(cardItem => {
      return cardItem?.fields?.title?.toLowerCase()?.includes(cardtype?.toLowerCase());
    })
    .map(cardItem => {
      return cardItem?.fields?.icon?.fields?.desktopImage?.fields?.file?.url;
    });
};

export const cardDeleteSuccessCallback = dispatch => {
  const reqPayload = {
    updateUserData: true,
  };
  dispatch(getCustomerInfo(reqPayload));
  toastifyFn(translateWithI18Next(TRANSLATE_MAPPING_KEY?.CARD_DELETED), '', 'card-deleted-toast');
};
